<template>
  <div class="ListFornecedores">
    <div class="ListFornecedores_header p-2">
      <div class="row">
        <div class="col-1">
          Ativo
        </div>
        <div class="col-10">
          Nome beneficiário
        </div>
        <div class="col-1" />
      </div>
    </div>
    <div v-for="(fornecedor, index) in propFornecedores"
         :key="index"
         class="ListFornecedores_item">
      <div class="row align-items-center">
        <div class="col-1 pl-4">
          <b-form-checkbox :id="`ativo_${index}`"
                           v-model="fornecedor.ativo"
                           switch
                           :value="1"
                           @change="atualizarFornecedor(fornecedor)" />
        </div>
        <div class="col-10">
          {{ fornecedor.nome }}
        </div>
        <div class="
             col-1">
          <div class="row d-inline-flex justify-content-between p-2">
            <div @click="editarFornecedor(fornecedor)">
              <icon-svg icon="pencil"
                        class="icon--sm icon-edit mr-4 icon-click" />
            </div>
            <div @click="excluirFornecedor(fornecedor)">
              <icon-svg icon="trash"
                        class="icons--red icon--sm icon-click" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListFornecedores',
    props: {
      propFornecedores: { type: Array, default: () => ([])}
    },
    methods: {
      async excluirFornecedor (fornecedor) {
        const res = await displayMessage('question', 'Tem certeza que deseja excluir este beneficiário?')

        if (res.value) {
          this.$emit('excluirFornecedor', fornecedor)
        }
      },
      editarFornecedor (fornecedor) {
        this.$emit('editarFornecedor', fornecedor)
      },
      atualizarFornecedor (fornecedor) {
        setTimeout(() => {
          this.$emit('atualizarFornecedor', fornecedor)
        }, 200)
      }
    }
  }
</script>

<style lang="scss">
  .ListFornecedores {
    display: table;
    border-collapse: collapse;
    width: 100%;

    &_header {
      border-radius: 4px 4px 0px 0px;
      background-color: #01bfa5;
      color: #000;
      font-size: 16px;
      font-weight: bold;
    }

    &_item {
      color: #000;
      font-size: 16px;
      display: table-row;
      border: 1px solid #696969;
    }
  }

  .icon-edit {
    fill: #696969;
  }

  .icon-click {
    cursor: pointer;
  }
</style>
